import { DefaultApi } from './api';
import { DataDocumentResponse } from './types';

export const getDataDocument = (document: string) =>
  DefaultApi.request<DataDocumentResponse>(`/document/${document}/inspect`, {
    method: 'GET',
  });
